import { useAnalytics } from '@repo/segment/Analytics';
import { useAnalyticsPageView } from '@repo/segment/Analytics/AnalyticsPageView';

type PageActionProps = {
  actionDestinationUrl?: string;
  actionInput?: string | null;
  actionName: string;
  actionSection: string;
  actionType?: string;
  additionalAttributes?: object;
  contextCampaignUtmCampaign?: string;
  parentActivityId?: string;
};

export const usePageAction = ({
  actionDestinationUrl,
  actionInput = null,
  actionName,
  actionSection,
  actionType,
  additionalAttributes,
  contextCampaignUtmCampaign,
  parentActivityId,
}: PageActionProps) => {
  const { analytics, deployableName, deployableVersion, deviceId, gitSha } = useAnalytics();
  const { pageViewId, pageType } = useAnalyticsPageView();
  const segmentInstance = analytics?.segmentInstance;

  const segmentProps = {
    action_input: actionInput,
    action_name: actionName,
    action_section: actionSection,
    action_type: actionType,
    action_location_url: typeof window !== 'undefined' && window?.location?.href,
    action_destination_url: actionDestinationUrl,
    context_campaign_utm_campaign: contextCampaignUtmCampaign,
    deployable_name: deployableName,
    deployable_version: deployableVersion,
    impression_pageview_id: pageViewId,
    traditional_device_id: deviceId,
    additional_attributes: { ...additionalAttributes, page_type: pageType },
    parent_activity_id: parentActivityId,
  };

  return (overrideProps?: Record<string, string | object> | null, callback?: (() => void) | null) =>
    segmentInstance &&
    void segmentInstance
      .track(
        'Page Action',
        {
          ...segmentProps,
          ...overrideProps,
          additional_attributes: {
            ...segmentProps.additional_attributes,
            ...(typeof overrideProps?.additional_attributes === 'object'
              ? overrideProps.additional_attributes
              : {}),
          },
        },
        {
          context: {
            app: {
              name: deployableName,
              version: gitSha,
            },
          },
        },
      )
      ?.finally(() => {
        callback?.();
      });
};
